import {useEnvironmentStore} from '@/env/useEnvironmentStore';

export const createMockServiceWorker = () => {
  return {
    install: async () => {
      const {environment} = useEnvironmentStore();

      if (environment.useMockingApiClients) {
        const {initMockServiceWorker} = await import('@/mocks/index');
        await initMockServiceWorker();
      }
    },
  };
};
